import { useEffect } from "react";
import "./style.css";

export const Video = () => {
  useEffect(() => {
    const videoEl = document.getElementsByClassName(
      "video__content"
    )[0] as HTMLVideoElement;
    videoEl.play();
  }, []);

  return (
    <div className="video__container">
      <video
        className="video__content"
        src="/video/video.mp4"
        muted
        autoPlay
        playsInline
        loop
      />
    </div>
  );
};
